<template>
    <div class="editform">
        <Form ref="pInfo"
            :model="pInfo"
            :rules="ruleValidate"
            :label-width="80">
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="菜单名称"
                    prop="title">
                    <Input v-model="pInfo.title"
                        placeholder=""
                        :maxlength="32"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="菜单代码"
                    prop="code">
                    <Input v-model="pInfo.code"
                        placeholder=""
                        :maxlength="32"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="显示隐藏"
                    prop="displayable">
                    <i-switch v-model="pInfo.displayable"
                        size="large"
                        :true-value="1"
                        :false-value="0">
                        <span slot="open">显示</span>
                        <span slot="close">隐藏</span>
                    </i-switch>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="是否授权"
                    prop="authc">
                    <i-switch v-model="pInfo.authc"
                        size="large"
                        :true-value="1"
                        :false-value="0">
                        <span slot="open">是</span>
                        <span slot="close">否</span>
                    </i-switch>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="路径"
                    prop="uri">
                    <Input v-model="pInfo.uri"
                        placeholder=""></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="模块"
                    prop="module">
                    <Input v-model="pInfo.module"
                        placeholder=""></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="图标"
                    prop="icon">
                    <Input v-model="pInfo.icon"
                        placeholder=""></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="排序"
                    prop="sortNum">
                    <input-number v-model="pInfo.sortNum"
                        placeholder=""
                        :allowNegative="false"
                        :allowDecimal="false"
                        :includeThousandsSeparator="false">
                    </input-number>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="说明"
                    prop="remark">
                    <Input type="textarea"
                        v-model="pInfo.remark"
                        placeholder="0/1000"
                        :rows="4"
                        :maxlength="1000"></Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { resView, resAdd, resUpdate } from "@/api/sys-res"
import { createNamespacedHelpers } from "vuex"
import Enum from "_u/enum"
import SelectDirectory from "./selectDirectory"
export default {
    name: "ResourceForm",
    components: {
        SelectDirectory
    },
    props: {
        id: {
            type: [String, Number],
            default: ""
        },
        pid: {
            type: [String, Number],
            require: true
        },
        type: {
            type: [String, Number],
            require: true
        },
        list: {
            type: Array,
            default: () => []
        }
    },
    inject: {
        $modal: { default: null }
    },
    data() {
        var data = {
            pInfo: {
                id: "",
                pid: this.pid,
                title: "",
                code: "",
                uri: "",
                module: "",
                icon: "",
                type: "",
                sortNum: "",
                displayable: "0",
                authc: "0",
                ver: "",
                remark: ""
            },
            RES_TYPE: Enum.get("resourceType")
        }
        data.ruleValidate = {
            title: [{ required: true, message: "标题必填", trigger: "blur" }]
        }
        return data
    },
    computed: {},
    methods: {
        fetch() {
            // 修改
            if (this.id) {
                return resView(this.id)
            } else {
                this.pInfo.type = this.type
                this.pInfo.pid = this.pid
                //默认显示
                this.pInfo.displayable = 1
                this.pInfo.authc = 1

                return Promise.resolve()
            }
        }
    },
    mounted() {
        var $pInfo = this.$refs.pInfo

        this.$modal.onBtnClick("confirm", (next, options) => {
            $pInfo.validate(valid => {
                if (valid) {
                    if (this.id) {
                        resUpdate(this.pInfo)
                            .then(
                                res => this.$Message.success("Success!"),
                                err => (options.closeModal = false)
                            )
                            .then(res => next())
                    } else {
                        resAdd(this.pInfo)
                            .then(
                                res => this.$Message.success("Success!"),
                                err => (options.closeModal = false)
                            )
                            .then(res => next())
                    }
                } else {
                    options.closeModal = false
                    next()
                }
            })
        })

        // 在窗口显示前加载数据
        this.$modal.beforeEnter(next => {
            Promise.all([this.fetch()]).then(args => {
                var [resource] = args

                if (resource) {
                    var resData = resource.data

                    Object.keys(this.pInfo).forEach(
                        name => (this.pInfo[name] = resData[name])
                    )
                }
                next()
            })
        })
    }
}
</script>